import { timeline } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import ScrollReveal from './ScrollReveal';

export default function Timeline() {
  return (
    <section className="bg-white">
      <div className="section-padding">
        <SectionHeading
          index="05"
          eyebrow="更新日历"
          title="每日更新，从不掉线"
          subtitle="全天候稳定更新节奏，追更不用等，新番抢先看。"
        />

        <div className="max-w-4xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {timeline.map((item, i) => (
              <ScrollReveal key={item.time} delay={i * 80}>
                <div className="group h-full relative rounded-lg border-2 border-gray-900 bg-white p-6 shadow-[4px_4px_0_0_#ff9db8] hover:shadow-[4px_4px_0_0_#1a1a1a] hover:-translate-y-1.5 transition-all duration-300 overflow-hidden">
                  <div className="absolute top-2 right-2 w-8 h-8 halftone-pink pointer-events-none" />
                  <span className="inline-flex items-center justify-center w-16 h-9 rounded-md border-2 border-gray-900 bg-pink-500 font-serif text-base font-bold text-white">
                    {item.time}
                  </span>
                  <h3 className="mt-4 text-base font-bold text-gray-900">{item.title}</h3>
                  <p className="mt-2 text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}